import { format } from "./inputFormatters";
import { useFilters } from "./setSearchParams";

class inputFunctions {
  changeObj(
    value: any,
    setState:
      | React.Dispatch<React.SetStateAction<{ [key: string]: any }>>
      | React.Dispatch<React.SetStateAction<{ [key: string]: any }[]>>,
    key: string,
    formatTo?: "toNumber" | "toPhoneNumber" | "toMoney" | "toVatnumber" | "toInteger"
  ) {
    setState((prev) => ({ ...prev, [key]: formatTo ? format[formatTo](value) : value }));
  }

  changeObjOfArr(
    item: { [key: string]: any },
    value: any,
    setState:
      | React.Dispatch<React.SetStateAction<{ [key: string]: any }>>
      | React.Dispatch<React.SetStateAction<{ [key: string]: any }[]>>,
    key: string,
    formatTo?: "toNumber" | "toPhoneNumber" | "toMoney" | "toVatnumber" | "toInteger"
  ) {
    setState((prev) =>
      prev.map((i: any) => (i.id === item.id ? { ...i, [key]: formatTo ? format[formatTo](value) : value } : i))
    );
  }
}

export const inputFunc = new inputFunctions();
